export default __webpack_public_path__ + "static/media/instruments.1064317b.svg";